import validate from "/home/anh/project/outsource/alobacsi/clinic booking/web-user-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import app_45webview_45global from "/home/anh/project/outsource/alobacsi/clinic booking/web-user-app/src/middleware/appWebview.global.ts";
import manifest_45route_45rule from "/home/anh/project/outsource/alobacsi/clinic booking/web-user-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  app_45webview_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/anh/project/outsource/alobacsi/clinic booking/web-user-app/src/middleware/auth.ts"),
  guest: () => import("/home/anh/project/outsource/alobacsi/clinic booking/web-user-app/src/middleware/guest.ts")
}